(() => {
  'use strict';
  const root = document.querySelector('[data-review-catalog]');
  if (!root) return;
  const grid = root.querySelector('[data-review-grid]');
  const cards = [...grid.querySelectorAll('[data-review-card]')];
  const forms = [...root.querySelectorAll('[data-review-filters]')];
  const sort = root.querySelector('[data-review-sort]');
  const dialog = root.querySelector('[data-catalog-filter-dialog]');
  let state = { min: '', max: '', availability: [], brands: [] };
  const brands = [...new Set(cards.map(card => card.dataset.reviewBrand).filter(Boolean))].sort((a, b) => a.localeCompare(b, 'nl'));

  for (const form of forms) {
    const options = form.querySelector('[data-review-brands]');
    for (const brand of brands) {
      const label = document.createElement('label');
      label.className = 'lp-facet__option';
      const input = document.createElement('input');
      input.type = 'checkbox'; input.value = brand; input.dataset.reviewBrand = '';
      const box = document.createElement('span'); box.className = 'lp-facet__box'; box.setAttribute('aria-hidden', 'true');
      const check = form.querySelector('.lp-facet__box .lp-icon');
      if (check) box.append(check.cloneNode(true));
      const text = document.createElement('span'); text.textContent = brand;
      const count = document.createElement('small'); count.textContent = cards.filter(card => card.dataset.reviewBrand === brand).length;
      label.append(input, box, text, count); options.append(label);
    }
    for (const count of form.querySelectorAll('[data-review-availability-count]')) {
      count.textContent = cards.filter(card => card.dataset.reviewAvailable === count.dataset.reviewAvailabilityCount).length;
    }
    const maximum = Math.max(0, ...cards.map(card => Number(card.dataset.reviewPrice)));
    form.querySelector('[data-review-max]').placeholder = (maximum / 100).toFixed(2);
  }

  function sync() {
    for (const form of forms) {
      form.querySelector('[data-review-min]').value = state.min;
      form.querySelector('[data-review-max]').value = state.max;
      for (const input of form.querySelectorAll('[data-review-availability]')) input.checked = state.availability.includes(input.value);
      for (const input of form.querySelectorAll('[data-review-brand]')) input.checked = state.brands.includes(input.value);
      form.querySelector('[data-review-error]').hidden = true;
    }
  }
  function update() {
    let visible = 0;
    const low = state.min === '' ? -Infinity : Math.round(Number(state.min) * 100);
    const high = state.max === '' ? Infinity : Math.round(Number(state.max) * 100);
    const ordered = [...cards].sort((a, b) => {
      if (sort.value === 'price-asc') return Number(a.dataset.reviewPrice) - Number(b.dataset.reviewPrice);
      if (sort.value === 'price-desc') return Number(b.dataset.reviewPrice) - Number(a.dataset.reviewPrice);
      if (sort.value === 'title-asc') return a.dataset.reviewTitle.localeCompare(b.dataset.reviewTitle, 'nl');
      return Number(a.dataset.reviewGroup) - Number(b.dataset.reviewGroup);
    });
    for (const card of ordered) {
      const price = Number(card.dataset.reviewPrice);
      card.hidden = price < low || price > high ||
        (state.availability.length > 0 && !state.availability.includes(card.dataset.reviewAvailable)) ||
        (state.brands.length > 0 && !state.brands.includes(card.dataset.reviewBrand));
      if (!card.hidden) visible++;
      grid.append(card);
    }
    const inRange = card => Number(card.dataset.reviewPrice) >= low && Number(card.dataset.reviewPrice) <= high;
    const matchesBrand = card => state.brands.length === 0 || state.brands.includes(card.dataset.reviewBrand);
    const matchesAvailability = card => state.availability.length === 0 || state.availability.includes(card.dataset.reviewAvailable);
    for (const form of forms) {
      for (const count of form.querySelectorAll('[data-review-availability-count]')) {
        count.textContent = cards.filter(card => inRange(card) && matchesBrand(card) && card.dataset.reviewAvailable === count.dataset.reviewAvailabilityCount).length;
      }
      for (const input of form.querySelectorAll('[data-review-brand]')) {
        input.closest('label').querySelector('small').textContent = cards.filter(card => inRange(card) && matchesAvailability(card) && card.dataset.reviewBrand === input.value).length;
      }
    }
    root.querySelector('[data-review-count]').textContent = visible;
    root.querySelector('[data-review-empty]').hidden = visible > 0;
  }
  function apply(form) {
    const min = form.querySelector('[data-review-min]');
    const max = form.querySelector('[data-review-max]');
    if (!form.reportValidity()) return false;
    const error = form.querySelector('[data-review-error]');
    if (min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value)) {
      error.textContent = 'De maximumprijs moet hoger zijn dan of gelijk zijn aan de minimumprijs.';
      error.hidden = false; max.focus(); return false;
    }
    state = { min: min.value, max: max.value,
      availability: [...form.querySelectorAll('[data-review-availability]:checked')].map(input => input.value),
      brands: [...form.querySelectorAll('[data-review-brand]:checked')].map(input => input.value) };
    sync(); update(); return true;
  }
  for (const form of forms) {
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (apply(form) && form.closest('dialog')) dialog.close();
    });
    form.addEventListener('change', event => {
      if (event.target.type === 'checkbox' && !form.closest('dialog')) apply(form);
    });
    form.addEventListener('input', () => { form.querySelector('[data-review-error]').hidden = true; });
    form.querySelector('[data-review-reset]').addEventListener('click', () => {
      form.reset();
      if (!form.closest('dialog')) apply(form);
    });
  }
  root.querySelector('[data-catalog-filter-open]').addEventListener('click', sync);
  sort.addEventListener('change', update);
  sync(); update();
})();
